import type { ServiceRouter } from "@fideus/service-api";
import { createTRPCContext } from "@trpc/tanstack-react-query";

export const { TRPCProvider, useTRPC } = createTRPCContext<ServiceRouter>();
